import { get } from 'lodash'

import { getUUIDv4 } from '@/src/utils/helper'

import { LAYER_TYPE } from '../layer'
import { LAYER_ACTION_TYPE } from './type'

export * from './type'
let ACION_SUPPORT = {}
export function setActionSupport(type, action) {
  ACION_SUPPORT[type] = action
}
function checkActionSupportExists(type) {
  return !!ACION_SUPPORT[type]
}
export function callActionSupport(type, ...params) {
  let action = ACION_SUPPORT[type]
  if (action) {
    return action(...params)
  }
}

export function LayerViewCreate(type, layer, readonly, layer_data) {
  switch (type) {
    case LAYER_TYPE.NBDS_VECTO_LAYER:
      return createNbdsVectorLayer(layer, readonly, layer_data)
    default:
      return createDefaultLayer(layer)
  }
}
function createNbdsVectorLayer(layer, readonly, layer_data) {
  let info = layer.info
  let temp = createDefaultLayer({
    id: getUUIDv4(),
    name: info.name,
    data_id: layer.data_id,
    style: layer.style,
    metadata: {
      bounds: info.bounds,
      fields: get(info, 'datastore_detail.fields', []),
    },
  })
  if (layer_data.image_urls && layer_data.image_urls[0]) {
    temp.image_url = layer_data.image_urls[0]
  }
  temp.type = LAYER_TYPE.NBDS_VECTO_LAYER
  temp.info = info
  if (checkActionSupportExists(LAYER_ACTION_TYPE.SHOW_TABLE)) {
    temp.menus.push({
      text: 'Danh sách đối tượng',
      click: (layer) => {
        callActionSupport(LAYER_ACTION_TYPE.SHOW_TABLE, layer)
      },
    })
  }
  if (checkActionSupportExists(LAYER_ACTION_TYPE.SHOW_LABEL)) {
    temp.show_label = false
    let menu = {
      text: temp.show_label ? 'Tắt nhãn' : 'Bật nhãn',
      id: LAYER_ACTION_TYPE.SHOW_LABEL,
      click: (layer) => {
        temp.show_label = !temp.show_label
        menu.text = temp.show_label ? 'Tắt nhãn' : 'Bật nhãn'
        callActionSupport(
          LAYER_ACTION_TYPE.SHOW_LABEL,
          layer,
          temp.show_label,
          menu
        )
      },
    }
    temp.menus.push(menu)
  }
  if (!readonly && checkActionSupportExists(LAYER_ACTION_TYPE.SHOW_STYLE)) {
    temp.menus.push({
      text: 'Cài đặt trình bày',
      click: (layer) => {
        callActionSupport(LAYER_ACTION_TYPE.SHOW_STYLE, layer)
      },
    })
    temp.menus.push({
      text: 'Cài đặt nhãn',
      click: (layer) => {
        callActionSupport(LAYER_ACTION_TYPE.SHOW_STYLE_LABEL, layer)
      },
    })
  }
  temp.disabled_opacity = readonly
  return temp
}
function createDefaultLayer(layer) {
  layer.metadata = Object.assign({}, layer.metadata)
  layer.show = layer.show != null ? layer.show : true
  let temp = {
    id: layer.id,
    name: layer.name,
    show: layer.show,
    opacity: 1,
    menus: [],
    info: layer,
    style: layer.style,
    legend: layer.legend,
    legend_show: false,
    get selected() {
      return layer.selected
    },
    set selected(value) {
      layer.selected = value
    },

    get metadata() {
      return layer.metadata
    },
    set metadata(value) {
      layer.metadata = value
    },

    data_id: layer.data_id,
    get field_geometry() {
      return layer.metadata.field_geometry || 'geometry'
    },
    get field_id() {
      return layer.metadata.field_id || 'id'
    },
  }
  temp.color = '#00725B'

  if (layer.show_group) {
    temp.group = layer.group
  }
  return temp
}
